import { crabDevice } from '@hfzq/crab-utils';
import { useMemoizedFn } from 'ahooks';
import { useEffect } from 'react';
import { clearLocalVarToken } from '@src/apis/helper/request-token';
import { CachePool } from '../cache-pool';
// import { getUserCode } from '../get-user-code';

const gobackPool = new CachePool<() => void>();
window.GoBackOnLoad = function () {
  // getUserCode();
  clearLocalVarToken();
  gobackPool.getPool().forEach((callback) => {
    callback();
  });
};

/**
 * 仅在小福牛中有效
 * 支持同时使用多次 useGoBack
 * 回调会被依次执行
 *
 * @param callback 回调
 */
export const useXfnGoback = (callback: () => void) => {
  if (!crabDevice.isTZT) {
    return;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const fn = useMemoizedFn(callback);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    gobackPool.add(fn);
    return () => {
      gobackPool.remove(fn);
    };
  }, [fn]);
};
